import axios from 'axios'

import {
    AcceptAutoScaleNamesResponse,
    AcceptAutoScaleNamesSelection,
    AcceptAutoScaleResponse,
    PageScaleView,
} from '../models/autoScale'
import { HTTPStatusCode } from '../shared/constants/http-status-codes'

const fetchAutoScaleForDocumentChunk = async (
    projectId: number,
    documentChunkId: number
): Promise<PageScaleView | null> => {
    try {
        // a page with no result is a normal answer, so it must not open the global error modal
        return await axios.get<void, PageScaleView>(
            `project/${projectId}/autoscale/document-chunk/${documentChunkId}`,
            {
                skipErrorModalForStatuses: [HTTPStatusCode.NOT_FOUND],
            }
        )
    } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 404) return null
        throw error
    }
}

const acceptAutoScaleForDocumentChunk = (
    projectId: number,
    documentChunkId: number
): Promise<AcceptAutoScaleResponse> =>
    axios.post<void, AcceptAutoScaleResponse>(`project/${projectId}/autoscale/document-chunk/${documentChunkId}/accept`)

const acceptAutoScaleNamesForDocumentChunk = (
    projectId: number,
    documentChunkId: number,
    selection: AcceptAutoScaleNamesSelection
): Promise<AcceptAutoScaleNamesResponse> =>
    axios.post<AcceptAutoScaleNamesSelection, AcceptAutoScaleNamesResponse>(
        `project/${projectId}/autoscale/document-chunk/${documentChunkId}/names/accept`,
        selection
    )

export { acceptAutoScaleForDocumentChunk, acceptAutoScaleNamesForDocumentChunk, fetchAutoScaleForDocumentChunk }
